import { render, staticRenderFns } from "./HomeAi.vue?vue&type=template&id=034bdd1c&scoped=true"
var script = {}
import style0 from "./HomeAi.vue?vue&type=style&index=0&id=034bdd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034bdd1c",
  null
  
)

export default component.exports